import styled from 'styled-components';

export const Wrapper = styled.div`
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding: ${({ theme }) => theme.spacing.x3};
  padding-inline-start: ${({ theme }) => theme.spacing.x6};
  background-color: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxShadow.md};
  display: flex;
  justify-content: space-between;
  max-width: 920px;
  margin-inline: auto;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    flex-direction: column;
  }
`;

export const DetailsWrapper = styled.div`
  flex-grow: 1;
`;
export const Details = styled.div`
  /* width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: start; */
  width: 100%;
  height: 100px;
  display: flex;
  + * {
    margin-top: ${({ theme }) => theme.spacing.x2};
  }
`;
export const AmountBlockWrapper = styled.div`
  display: flex;
  margin: -${({ theme }) => theme.spacing.x2};
  margin-inline-start: ${({ theme }) => theme.spacing.x6};
  > * {
    padding: ${({ theme }) => theme.spacing.x1};
    width: 200px;
  }
  @media (max-width: ${({ theme }) => theme.media.md}) {
    justify-content: space-between;
    margin-inline-start: 0px;
    margin-top: ${({ theme }) => theme.spacing.x2};
  }
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const DetailsCenterBlock = styled.div`
  /* width: ${({ theme }) => theme.spacing.x15};
  margin-inline: ${({ theme }) => theme.spacing.x6}; */
  flex-grow: 1;
  flex-shrink: 3;
  flex-basis: 100px;
  text-align: center;
  color: ${({ theme }) => theme.palette.lightGray};
`;
export const Flys = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 100px;
`;

export const DetailsCenterBlockIcon = styled.div``;

export const TinyText = styled.span`
  font-size: ${({ theme }) => theme.fs.xxs};
  font-weight: 400;
  line-height: ${({ theme }) => theme.spacing.x4};
  color: ${({ theme }) => theme.palette.lightGray};
  display: block;
`;

export const SmallText = styled(TinyText)`
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const FlightNumber = styled(SmallText)`
  display: inline-block;
  margin-top: ${({ theme }) => theme.spacing.x1};
`;
